export default __webpack_public_path__ + "locales/bg/BackupCodesDialog.json?hash=8c3b094be9431183bafebac822ea9aaf";